import axios, { AxiosPromise } from 'axios';
import config from '@/config';
import { ResultFile } from '@/modules/analysis/models/analysisRequest';

const resourceEndpoint = `${config.api.url}${config.api.privateEndpointsPrefix}${config.api.endpoints.resultFile}`;

export function findAll(): AxiosPromise<ResultFile[]> {
  return axios.get(`${resourceEndpoint}/all`, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

export function create(files: File[], requestId: string): AxiosPromise<void> {
  const filesFormData = new FormData();
  for (const [index, file] of files.entries()) {
    filesFormData.append('file' + index, file);
  }
  return axios.post(`${resourceEndpoint}/analysis-request/${requestId}`, filesFormData, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'multipart/form-data'
    }
  });
}

export function download(id: string): AxiosPromise<Blob> {
  return axios.get(`${resourceEndpoint}/${id}`, {
    withCredentials: true,
    responseType: 'blob'
  });
}

export function publish(id: string): AxiosPromise<void> {
  return axios.put(`${resourceEndpoint}/${id}/publish`, {
    withCredentials: true,
    headers: {
      Accept: 'application/json'
    }
  });
}

export function destroy(id: string): AxiosPromise<void> {
  return axios.delete(`${resourceEndpoint}/${id}`, {
    withCredentials: true,
    headers: {
      Accept: 'application/json'
    }
  });
}
